import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import RouteTabComponent from './RouteTabComponent';
import componentBase from '../../../../../../../src/lib/component-base';

@componentBase('OtherStopsComponent')
export default class OtherStopsComponent extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    params: PropTypes.object,
    segments: PropTypes.array,
    selectedRouteIndex: PropTypes.number,
    status: PropTypes.object,
  };

  static defaultProps = {
    arrivalAirport: null,
    departureAirport: null,
    ticketHeader: null,
    segments: null,
    selectedRouteIndex: 0,
    status: null,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      divStyle: {
        margin: '0',
        width: '100%',
      },
      textStyle: {
        margin: '10px',
        fontSize: '12pt',
        display: 'inline-block',
      },
      tabsStyle: {
        minWidth: '200px',
        paddingRight: '0',
        right: '0',
      },
    };
  }

  handleRouteTabClick = (url) => {
    this.context.reportButtonPress('DifferentSegment');
    this.props.dispatch(push(url));
  }

  render() {
    if (this.props.segments.length > 1) {
      const {
        carrier, flightNumber, year, month, day,
      } = this.props.params;

      this.routeTabs = this.props.segments.map((segment, i) => {
        const url = `/flight-tracker/${carrier}/${flightNumber}/${year}/${month}/${day}/${segment.flightId}`;
        const key = `component-${i}`;

        return (
          <span
            key={key}
            onClick={() => this.handleRouteTabClick(url)}
            style={{ cursor: 'pointer' }}
          >
            <RouteTabComponent
              small
              index={i}
              last={i === this.props.segments.length - 1}
              unselected={this.props.selectedRouteIndex !== i}
              className={this.props.selectedRouteIndex === i ? `flight-ticket ${this.props.status.color}` : ''}
              arrivalFS={segment.ticketHeader.arrivalAirport.fs}
              departureFS={segment.ticketHeader.departureAirport.fs}
            />
          </span>
        );
      });

      return (
        <div style={this.muiDefaultProps.divStyle}>
          <div className='col-sm-3'>
            <h4 style={this.muiDefaultProps.textStyle}>View Other Stops for this Flight</h4>
          </div>
          <div style={this.muiDefaultProps.tabsStyle} className='col-sm-8'>
            {this.routeTabs}
          </div>
        </div>
      );
    }

    return (<div />);
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightInformation/children/OtherStopsComponent.js